const EVENT_TYPES = {
  REQUEST_TOKEN: "REQUEST_TOKEN",
  RESPONSE_TOKEN: "RESPONSE_TOKEN",
};

class RequestToken {
  token = null;

  constructor() {
    window.addEventListener("message", (event) => {
      if (event.data.source !== "host") {
        return;
      }

      switch (event.data.type) {
        case EVENT_TYPES.RESPONSE_TOKEN:
          this.token = event.data.payload;
          break;
      }
    });
  }

  sendRequest = () => {
    window.parent.postMessage(
      {
        source: import.meta.url,
        type: EVENT_TYPES.REQUEST_TOKEN,
      },
      "*",
    );
  };
}

export default new RequestToken();
